// src/contexts/DonationContext.tsx
import React, { createContext, useContext, useState } from 'react';

interface DonationContextType {
  showDonateModal: boolean;
  setShowDonateModal: (show: boolean) => void;
  donationStatus: 'idle' | 'processing' | 'completed' | 'failed';
  setDonationStatus: (status: 'idle' | 'processing' | 'completed' | 'failed') => void;
}

const DonationContext = createContext<DonationContextType | undefined>(undefined);

export const DonationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showDonateModal, setShowDonateModal] = useState(false);
  const [donationStatus, setDonationStatus] = useState<'idle' | 'processing' | 'completed' | 'failed'>('idle');

  return (
    <DonationContext.Provider 
      value={{ 
        showDonateModal, 
        setShowDonateModal,
        donationStatus,
        setDonationStatus
      }}
    >
      {children}
    </DonationContext.Provider>
  );
};

export const useDonation = () => {
  const context = useContext(DonationContext);
  if (context === undefined) {
    throw new Error('useDonation must be used within a DonationProvider');
  }
  return context;
};
